// extracted by mini-css-extract-plugin
module.exports = {"steps-section":"learning-steps-section_steps-section__XMI3U","section-title":"learning-steps-section_section-title__cAybh","steps":"learning-steps-section_steps__3WjMJ"};